import { useState } from 'preact/hooks';
import { useApi } from '../../../hooks/useApi.js';
import { Button } from '../../../components/Button.jsx';

export const ReadingPicker = ({ open, excludeIds = [], onClose, onPick }) => {
  const [search, setSearch] = useState('');
  const { data: readings, loading } = useApi(open ? `/ink-density${search ? `?search=${encodeURIComponent(search)}` : ''}` : null);
  if (!open) return null;

  const candidates = (readings ?? []).filter((r) => !excludeIds.includes(r.id));

  return (
    <div class="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/55 px-4 py-10" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div class="w-full max-w-2xl overflow-hidden rounded-xl border border-border-subtle bg-bg-base">
        <div class="border-b border-border-subtle bg-bg-header px-5 py-4">
          <p class="eyebrow mb-1" style={{ color: '#F5EEDC' }}>Add reading</p>
          <input
            type="search"
            value={search}
            onInput={(e) => setSearch(e.currentTarget.value)}
            placeholder="Search by job number, name, or customer…"
            class="block w-full rounded-md border border-border-strong bg-bg-card px-3 py-1.5 text-sm focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
            autoFocus
          />
        </div>
        <div class="max-h-[60vh] overflow-y-auto">
          {loading && <p class="p-6 text-center text-sm text-text-tertiary">Loading…</p>}
          {!loading && candidates.length === 0 && (
            <p class="p-6 text-center text-sm text-text-tertiary">
              {(readings ?? []).length === 0 ? 'No readings yet.' : 'All readings already included.'}
            </p>
          )}
          {candidates.map((r) => (
            <button
              key={r.id}
              type="button"
              onClick={() => onPick(r)}
              class="block w-full border-b border-border-subtle px-5 py-3 text-left hover:bg-bg-hover"
            >
              <div class="flex items-baseline justify-between gap-3">
                <div>
                  <span class="font-mono text-[13px] font-semibold text-text-primary">{r.jobNumber || `#${r.id}`}</span>
                  {r.jobName && <span class="ml-2 text-[12px] text-text-secondary">{r.jobName}</span>}
                </div>
                <span class="font-mono text-[11px] text-text-tertiary">{r.readingDate || ''}</span>
              </div>
              <div class="mt-0.5 text-[11px] text-text-tertiary">
                {r.customerName}{r.profileLabel ? ` · ${r.profileLabel}` : ''}
              </div>
            </button>
          ))}
        </div>
        <div class="flex justify-end gap-2 border-t border-border-subtle bg-bg-header px-5 py-3">
          <Button variant="secondary" onClick={onClose}>Close</Button>
        </div>
      </div>
    </div>
  );
};
